export default __webpack_public_path__ + "static/media/fsk-06.fedd2d63.jpg";